import React, { Component } from "react";
import { ConstantBasedPicker } from "@openimis/fe-core";

import { HOUSEHOLDITEMS } from "../constants";

class HouseholdItems extends Component {

    render() {
        const { readOnly = false, required = false, withNull = true, nullLabel = null } = this.props;
        
        return <ConstantBasedPicker
            module="niue"
            constants={HOUSEHOLDITEMS}
            readOnly={readOnly}
            {...this.props}
        />
    }
}

export default HouseholdItems;